const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            height: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            shadowColor: {
                type: 'string',
            },
            shadowOffset: {
                type: 'object',
            },
            shadowOpacity: {
                type: 'number',
            },
            shadowRadius: {
                type: 'number',
            },
            backgroundColor: {
                type: 'string',
            },
            display: {
                type: 'string',
            },
            textProps: {
                type: 'object',
            },
        },
        appearances: {
            basic: {
                default: true,
            },
        },
        variantGroups: {
            status: {
                neutral: {
                    default: true,
                },
                brand: {
                    default: false,
                },
                flat: {
                    default: false,
                },
            },
            size: {
                small: {
                    default: false,
                },
                medium: {
                    default: false,
                },
            },
        },
        states: {},
    },
    appearances: {
        basic: {
            mapping: {
                height: 72,
                paddingHorizontal: 24,
                paddingVertical: 8,
                shadowColor: '#000',
                shadowOffset: {
                    width: 0,
                    height: -4,
                },
                shadowOpacity: 0.48,
                shadowRadius: 11.22,
            },
            variantGroups: {
                status: {
                    neutral: {
                        backgroundColor: 'color-text-basic',
                        textProps: {
                            h2: true,
                            status: 'dark',
                        },
                    },
                    brand: {
                        backgroundColor: 'color-brand-800',
                        textProps: {
                            h2: true,
                            status: 'basic',
                        },
                    },
                    flat: {
                        backgroundColor: 'color-flat-200',
                        textProps: {
                            h2: true,
                            status: 'basic',
                        },
                    },
                },
                size: {
                    small: {
                        height: 48,
                    },
                    medium: {
                        height: 56,
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAHeader.theme.alucio.js.map